var map = {
	"./ar/alt-tags.json": [
		42186,
		"src_i18n_translations_ar_alt-tags_json"
	],
	"./ar/assets.json": [
		88920,
		"src_i18n_translations_ar_assets_json"
	],
	"./ar/common.json": [
		10411,
		"src_i18n_translations_ar_common_json"
	],
	"./ar/exchange.json": [
		12191,
		"src_i18n_translations_ar_exchange_json"
	],
	"./ar/farms.json": [
		50766,
		"src_i18n_translations_ar_farms_json"
	],
	"./ar/fees.json": [
		1223,
		"src_i18n_translations_ar_fees_json"
	],
	"./ar/glossary.json": [
		71361,
		"src_i18n_translations_ar_glossary_json"
	],
	"./ar/header.json": [
		61508,
		"src_i18n_translations_ar_header_json"
	],
	"./ar/home.json": [
		6202,
		"src_i18n_translations_ar_home_json"
	],
	"./ar/liquidity.json": [
		37662,
		"src_i18n_translations_ar_liquidity_json"
	],
	"./ar/orders.json": [
		538,
		"src_i18n_translations_ar_orders_json"
	],
	"./ar/portfolio.json": [
		80551,
		"src_i18n_translations_ar_portfolio_json"
	],
	"./ar/queue.json": [
		78429,
		"src_i18n_translations_ar_queue_json"
	],
	"./ar/wallet.json": [
		9580,
		"src_i18n_translations_ar_wallet_json"
	],
	"./ar/warnings.json": [
		47266,
		"src_i18n_translations_ar_warnings_json"
	],
	"./de/alt-tags.json": [
		10717,
		"src_i18n_translations_de_alt-tags_json"
	],
	"./de/assets.json": [
		96717,
		"src_i18n_translations_de_assets_json"
	],
	"./de/common.json": [
		55015,
		"src_i18n_translations_de_common_json"
	],
	"./de/exchange.json": [
		61960,
		"src_i18n_translations_de_exchange_json"
	],
	"./de/farms.json": [
		6258,
		"src_i18n_translations_de_farms_json"
	],
	"./de/fees.json": [
		23420,
		"src_i18n_translations_de_fees_json"
	],
	"./de/glossary.json": [
		87472,
		"src_i18n_translations_de_glossary_json"
	],
	"./de/header.json": [
		97275,
		"src_i18n_translations_de_header_json"
	],
	"./de/home.json": [
		87499,
		"src_i18n_translations_de_home_json"
	],
	"./de/liquidity.json": [
		2881,
		"src_i18n_translations_de_liquidity_json"
	],
	"./de/orders.json": [
		62914,
		"src_i18n_translations_de_orders_json"
	],
	"./de/portfolio.json": [
		97377,
		"src_i18n_translations_de_portfolio_json"
	],
	"./de/queue.json": [
		99475,
		"src_i18n_translations_de_queue_json"
	],
	"./de/wallet.json": [
		54863,
		"src_i18n_translations_de_wallet_json"
	],
	"./de/warnings.json": [
		90114,
		"src_i18n_translations_de_warnings_json"
	],
	"./en/alt-tags.json": [
		43512,
		"src_i18n_translations_en_alt-tags_json"
	],
	"./en/assets.json": [
		48946,
		"src_i18n_translations_en_assets_json"
	],
	"./en/common.json": [
		3368,
		"src_i18n_translations_en_common_json"
	],
	"./en/error-fallback.json": [
		68107,
		"src_i18n_translations_en_error-fallback_json"
	],
	"./en/exchange.json": [
		65665,
		"src_i18n_translations_en_exchange_json"
	],
	"./en/farms.json": [
		89771,
		"src_i18n_translations_en_farms_json"
	],
	"./en/fees.json": [
		33466,
		"src_i18n_translations_en_fees_json"
	],
	"./en/first-visits.json": [
		47639,
		"src_i18n_translations_en_first-visits_json"
	],
	"./en/glossary.json": [
		31684,
		"src_i18n_translations_en_glossary_json"
	],
	"./en/header.json": [
		64073,
		"src_i18n_translations_en_header_json"
	],
	"./en/home.json": [
		71498,
		"src_i18n_translations_en_home_json"
	],
	"./en/liquidity.json": [
		8187,
		"src_i18n_translations_en_liquidity_json"
	],
	"./en/loading.json": [
		83606,
		"src_i18n_translations_en_loading_json"
	],
	"./en/news.json": [
		90909,
		"src_i18n_translations_en_news_json"
	],
	"./en/not-found.json": [
		31939,
		"src_i18n_translations_en_not-found_json"
	],
	"./en/orders.json": [
		97839,
		"src_i18n_translations_en_orders_json"
	],
	"./en/portfolio.json": [
		14930,
		"src_i18n_translations_en_portfolio_json"
	],
	"./en/queue.json": [
		65664,
		"src_i18n_translations_en_queue_json"
	],
	"./en/taste-test.json": [
		66843,
		"src_i18n_translations_en_taste-test_json"
	],
	"./en/transactions.json": [
		3420,
		"src_i18n_translations_en_transactions_json"
	],
	"./en/wallet.json": [
		86782,
		"src_i18n_translations_en_wallet_json"
	],
	"./en/warnings.json": [
		91067,
		"src_i18n_translations_en_warnings_json"
	],
	"./es/alt-tags.json": [
		48341,
		"src_i18n_translations_es_alt-tags_json"
	],
	"./es/assets.json": [
		58143,
		"src_i18n_translations_es_assets_json"
	],
	"./es/common.json": [
		49560,
		"src_i18n_translations_es_common_json"
	],
	"./es/exchange.json": [
		88899,
		"src_i18n_translations_es_exchange_json"
	],
	"./es/farms.json": [
		66412,
		"src_i18n_translations_es_farms_json"
	],
	"./es/fees.json": [
		82160,
		"src_i18n_translations_es_fees_json"
	],
	"./es/glossary.json": [
		58228,
		"src_i18n_translations_es_glossary_json"
	],
	"./es/header.json": [
		39722,
		"src_i18n_translations_es_header_json"
	],
	"./es/home.json": [
		57123,
		"src_i18n_translations_es_home_json"
	],
	"./es/liquidity.json": [
		81469,
		"src_i18n_translations_es_liquidity_json"
	],
	"./es/orders.json": [
		55832,
		"src_i18n_translations_es_orders_json"
	],
	"./es/portfolio.json": [
		75241,
		"src_i18n_translations_es_portfolio_json"
	],
	"./es/queue.json": [
		33416,
		"src_i18n_translations_es_queue_json"
	],
	"./es/wallet.json": [
		94796,
		"src_i18n_translations_es_wallet_json"
	],
	"./es/warnings.json": [
		89843,
		"src_i18n_translations_es_warnings_json"
	],
	"./fr/alt-tags.json": [
		61199,
		"src_i18n_translations_fr_alt-tags_json"
	],
	"./fr/assets.json": [
		31055,
		"src_i18n_translations_fr_assets_json"
	],
	"./fr/common.json": [
		20701,
		"src_i18n_translations_fr_common_json"
	],
	"./fr/exchange.json": [
		53782,
		"src_i18n_translations_fr_exchange_json"
	],
	"./fr/farms.json": [
		74472,
		"src_i18n_translations_fr_farms_json"
	],
	"./fr/fees.json": [
		56121,
		"src_i18n_translations_fr_fees_json"
	],
	"./fr/glossary.json": [
		20728,
		"src_i18n_translations_fr_glossary_json"
	],
	"./fr/header.json": [
		94862,
		"src_i18n_translations_fr_header_json"
	],
	"./fr/home.json": [
		42863,
		"src_i18n_translations_fr_home_json"
	],
	"./fr/liquidity.json": [
		79170,
		"src_i18n_translations_fr_liquidity_json"
	],
	"./fr/orders.json": [
		67955,
		"src_i18n_translations_fr_orders_json"
	],
	"./fr/portfolio.json": [
		99347,
		"src_i18n_translations_fr_portfolio_json"
	],
	"./fr/queue.json": [
		39732,
		"src_i18n_translations_fr_queue_json"
	],
	"./fr/wallet.json": [
		35753,
		"src_i18n_translations_fr_wallet_json"
	],
	"./fr/warnings.json": [
		47766,
		"src_i18n_translations_fr_warnings_json"
	],
	"./it/alt-tags.json": [
		82582,
		"src_i18n_translations_it_alt-tags_json"
	],
	"./it/assets.json": [
		43052,
		"src_i18n_translations_it_assets_json"
	],
	"./it/common.json": [
		39256,
		"src_i18n_translations_it_common_json"
	],
	"./it/exchange.json": [
		29810,
		"src_i18n_translations_it_exchange_json"
	],
	"./it/farms.json": [
		74443,
		"src_i18n_translations_it_farms_json"
	],
	"./it/fees.json": [
		93543,
		"src_i18n_translations_it_fees_json"
	],
	"./it/glossary.json": [
		64460,
		"src_i18n_translations_it_glossary_json"
	],
	"./it/header.json": [
		17032,
		"src_i18n_translations_it_header_json"
	],
	"./it/home.json": [
		67270,
		"src_i18n_translations_it_home_json"
	],
	"./it/liquidity.json": [
		12206,
		"src_i18n_translations_it_liquidity_json"
	],
	"./it/orders.json": [
		49777,
		"src_i18n_translations_it_orders_json"
	],
	"./it/portfolio.json": [
		51804,
		"src_i18n_translations_it_portfolio_json"
	],
	"./it/queue.json": [
		98678,
		"src_i18n_translations_it_queue_json"
	],
	"./it/wallet.json": [
		47341,
		"src_i18n_translations_it_wallet_json"
	],
	"./it/warnings.json": [
		30035,
		"src_i18n_translations_it_warnings_json"
	],
	"./ja/alt-tags.json": [
		20980,
		"src_i18n_translations_ja_alt-tags_json"
	],
	"./ja/assets.json": [
		2005,
		"src_i18n_translations_ja_assets_json"
	],
	"./ja/common.json": [
		82692,
		"src_i18n_translations_ja_common_json"
	],
	"./ja/exchange.json": [
		66892,
		"src_i18n_translations_ja_exchange_json"
	],
	"./ja/farms.json": [
		72951,
		"src_i18n_translations_ja_farms_json"
	],
	"./ja/fees.json": [
		82830,
		"src_i18n_translations_ja_fees_json"
	],
	"./ja/glossary.json": [
		87703,
		"src_i18n_translations_ja_glossary_json"
	],
	"./ja/header.json": [
		47522,
		"src_i18n_translations_ja_header_json"
	],
	"./ja/home.json": [
		45340,
		"src_i18n_translations_ja_home_json"
	],
	"./ja/liquidity.json": [
		69770,
		"src_i18n_translations_ja_liquidity_json"
	],
	"./ja/orders.json": [
		58225,
		"src_i18n_translations_ja_orders_json"
	],
	"./ja/portfolio.json": [
		47154,
		"src_i18n_translations_ja_portfolio_json"
	],
	"./ja/queue.json": [
		56866,
		"src_i18n_translations_ja_queue_json"
	],
	"./ja/wallet.json": [
		39848,
		"src_i18n_translations_ja_wallet_json"
	],
	"./ja/warnings.json": [
		28583,
		"src_i18n_translations_ja_warnings_json"
	],
	"./nl/alt-tags.json": [
		49753,
		"src_i18n_translations_nl_alt-tags_json"
	],
	"./nl/assets.json": [
		27978,
		"src_i18n_translations_nl_assets_json"
	],
	"./nl/common.json": [
		772,
		"src_i18n_translations_nl_common_json"
	],
	"./nl/exchange.json": [
		44619,
		"src_i18n_translations_nl_exchange_json"
	],
	"./nl/farms.json": [
		24297,
		"src_i18n_translations_nl_farms_json"
	],
	"./nl/fees.json": [
		18680,
		"src_i18n_translations_nl_fees_json"
	],
	"./nl/glossary.json": [
		15201,
		"src_i18n_translations_nl_glossary_json"
	],
	"./nl/header.json": [
		71142,
		"src_i18n_translations_nl_header_json"
	],
	"./nl/home.json": [
		43630,
		"src_i18n_translations_nl_home_json"
	],
	"./nl/liquidity.json": [
		92761,
		"src_i18n_translations_nl_liquidity_json"
	],
	"./nl/orders.json": [
		23595,
		"src_i18n_translations_nl_orders_json"
	],
	"./nl/portfolio.json": [
		17805,
		"src_i18n_translations_nl_portfolio_json"
	],
	"./nl/queue.json": [
		6862,
		"src_i18n_translations_nl_queue_json"
	],
	"./nl/wallet.json": [
		60495,
		"src_i18n_translations_nl_wallet_json"
	],
	"./nl/warnings.json": [
		14817,
		"src_i18n_translations_nl_warnings_json"
	],
	"./pt/alt-tags.json": [
		5564,
		"src_i18n_translations_pt_alt-tags_json"
	],
	"./pt/assets.json": [
		69016,
		"src_i18n_translations_pt_assets_json"
	],
	"./pt/common.json": [
		48245,
		"src_i18n_translations_pt_common_json"
	],
	"./pt/exchange.json": [
		23077,
		"src_i18n_translations_pt_exchange_json"
	],
	"./pt/farms.json": [
		98552,
		"src_i18n_translations_pt_farms_json"
	],
	"./pt/fees.json": [
		64056,
		"src_i18n_translations_pt_fees_json"
	],
	"./pt/glossary.json": [
		28846,
		"src_i18n_translations_pt_glossary_json"
	],
	"./pt/header.json": [
		14862,
		"src_i18n_translations_pt_header_json"
	],
	"./pt/home.json": [
		10864,
		"src_i18n_translations_pt_home_json"
	],
	"./pt/liquidity.json": [
		10273,
		"src_i18n_translations_pt_liquidity_json"
	],
	"./pt/orders.json": [
		93086,
		"src_i18n_translations_pt_orders_json"
	],
	"./pt/portfolio.json": [
		67540,
		"src_i18n_translations_pt_portfolio_json"
	],
	"./pt/queue.json": [
		59856,
		"src_i18n_translations_pt_queue_json"
	],
	"./pt/wallet.json": [
		76368,
		"src_i18n_translations_pt_wallet_json"
	],
	"./pt/warnings.json": [
		47347,
		"src_i18n_translations_pt_warnings_json"
	],
	"./ru/alt-tags.json": [
		89326,
		"src_i18n_translations_ru_alt-tags_json"
	],
	"./ru/assets.json": [
		17709,
		"src_i18n_translations_ru_assets_json"
	],
	"./ru/common.json": [
		64464,
		"src_i18n_translations_ru_common_json"
	],
	"./ru/exchange.json": [
		96993,
		"src_i18n_translations_ru_exchange_json"
	],
	"./ru/farms.json": [
		53872,
		"src_i18n_translations_ru_farms_json"
	],
	"./ru/fees.json": [
		77147,
		"src_i18n_translations_ru_fees_json"
	],
	"./ru/glossary.json": [
		19608,
		"src_i18n_translations_ru_glossary_json"
	],
	"./ru/header.json": [
		41160,
		"src_i18n_translations_ru_header_json"
	],
	"./ru/home.json": [
		86353,
		"src_i18n_translations_ru_home_json"
	],
	"./ru/liquidity.json": [
		61091,
		"src_i18n_translations_ru_liquidity_json"
	],
	"./ru/orders.json": [
		9561,
		"src_i18n_translations_ru_orders_json"
	],
	"./ru/portfolio.json": [
		19967,
		"src_i18n_translations_ru_portfolio_json"
	],
	"./ru/queue.json": [
		26064,
		"src_i18n_translations_ru_queue_json"
	],
	"./ru/wallet.json": [
		51002,
		"src_i18n_translations_ru_wallet_json"
	],
	"./ru/warnings.json": [
		83864,
		"src_i18n_translations_ru_warnings_json"
	],
	"./th/alt-tags.json": [
		95766,
		"src_i18n_translations_th_alt-tags_json"
	],
	"./th/assets.json": [
		37859,
		"src_i18n_translations_th_assets_json"
	],
	"./th/common.json": [
		75085,
		"src_i18n_translations_th_common_json"
	],
	"./th/exchange.json": [
		15569,
		"src_i18n_translations_th_exchange_json"
	],
	"./th/farms.json": [
		91832,
		"src_i18n_translations_th_farms_json"
	],
	"./th/fees.json": [
		92066,
		"src_i18n_translations_th_fees_json"
	],
	"./th/glossary.json": [
		9862,
		"src_i18n_translations_th_glossary_json"
	],
	"./th/header.json": [
		27131,
		"src_i18n_translations_th_header_json"
	],
	"./th/home.json": [
		51055,
		"src_i18n_translations_th_home_json"
	],
	"./th/liquidity.json": [
		46918,
		"src_i18n_translations_th_liquidity_json"
	],
	"./th/orders.json": [
		98979,
		"src_i18n_translations_th_orders_json"
	],
	"./th/portfolio.json": [
		61606,
		"src_i18n_translations_th_portfolio_json"
	],
	"./th/queue.json": [
		21798,
		"src_i18n_translations_th_queue_json"
	],
	"./th/wallet.json": [
		8995,
		"src_i18n_translations_th_wallet_json"
	],
	"./th/warnings.json": [
		37315,
		"src_i18n_translations_th_warnings_json"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 35698;
module.exports = webpackAsyncContext;